<div class="card pt-0 mb-5">
  <div class="card-header">
      <h4>Internal Audit Report</h4>
    </div>
  <div class="card-body">
    <form (ngSubmit)="onSubmit(orvreport.value)" [formGroup]="orvreport">
      <div>
        <div class="row hidden">
          <div class="col-sm-4">
            <div class="mb-3">
              <label class="form-label">Merchant Name <span aria-hidden="true" class="symbol required"
                  style="color:red;">*</span></label>
              <ng-select formControlName="merchantId" (change)="onMerchantSearch($event)"
                placeholder="merchantId">
                <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                  {{merchant.merchant_name}} ({{merchant.MerchantId}})
                </ng-option>
              </ng-select>
              <div *ngIf="!merchantdis" class="text-danger mt-1">
               Please select Merchant !
              </div>
            </div>
            </div>
            <div class="col-sm-4">
                  <label class="form-label">File Upload <span aria-hidden="true" class="symbol required"
                      style="color:red;">*</span></label>
                      <br>
                      <div class="mb-3">
<label class="input-group-btn">
  <input type="file" class="form-control form-control-sm" formControlName="fileupload"  accept="application/pdf"  [style.color]="true ? 'limegreen' : ''" (change)="onFileSelected($event)" />
  <!-- <input   class="form-control form-control-sm" (change)="this.onFileSelected($event)"
                                    [style.color]="true ? 'limegreen' : ''"
                                    formControlName="fileupload"
                                     type="file"> -->
                  </label>
                  <div *ngIf="!filedis" class="text-danger mt-1">
                    Please Upload the PDF File Only!
                   </div>
              </div>
            </div>
            <div class="col-sm-2">
              <br>
              <div class="mb-3">
              <button class="form-control btn btn-primary" [disabled]="disableUploadbtn"
                    type="submit"
                    value="Submit">Save
            </button>
            </div>
            </div>
        </div>
        </div>
        </form>
  </div>
</div>
<div class="row" style="min-height: 300px">
  <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">
    <ag-grid-angular [enableCellTextSelection]=true  (filterModified)="onFilterModified($event)"
      (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
      (rowDoubleClicked)="onRowDoubleClicked($event)" [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
      [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" [rowModelType]=""
      [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
      style="width: 100%; height: auto;">
    </ag-grid-angular>
  </div>
</div>
<div class="row bg-white p-2 mt-0">
<div class="col-md-4">
  <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
    class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
    <option [ngValue]="10">10</option>
    <option [ngValue]="20">20</option>
    <option [ngValue]="30">30</option>
  </select>
</div>
<div class="col-md-8">
  <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
    [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true"
    class="d-flex justify-content-end col-8 align-right">
  </ngb-pagination>
</div>
</div>